import React from 'react';
/**
 * Returns SearchForm for User Account
 * 
 * @param {string} key the account name.
 * @returns {object} the validator.
 */
export function getForm(accountName) {
    let form = null;
    try {
        form = require('./ExclusiveSearchForm.' + accountName);
        return form.default;
    } catch (error) {
        form = null;
    }

    return NOEF;
}
/**
 * Este componente nunca deberia verse 
 * pero es un alerta para que alguien nos informe de que hay algo mal configurado.
 */
class NOEF extends React.Component {
    componentDidMount() {
        this.setState({ val: 'two' });
    }
    render() {
        return <p>No Exclusive form for {this.props.accountName}<br />
            <a href='mailto:b2bsupport@olympiaviajes.es'>Please contact system administrator or support team</a></p>;
    }
}


// WEBPACK FOOTER //
// ./src/components/SearchContent/ExclusiveSearchForms/ExclusiveSearchFormFactory.js